import api from "./api.service";

export interface DashboardFilters {
  annee?: number;
  region_id?: number;
  departement_id?: number;
  commune_id?: number;
  haras_id?: number;
}

const DashboardService = {
  async get(filters: DashboardFilters = {}): Promise<any> {
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== null && v !== undefined)
    );
    const query = new URLSearchParams(params as any).toString();
    const { data } = await api.get(`/dashboard${query ? "?" + query : ""}`);
    return data;
  },
};

export default DashboardService;
